import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { verifyEmail } from '../services/emailService';
import "./EmailVerify.css";

const EmailVerify = () => {
  const [pins, setPins] = useState(Array(6).fill(''));
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [timer, setTimer] = useState(60);
  const [isResendEnabled, setIsResendEnabled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || 'no-email@example.com';
  const role = location.state?.role || 'Traveler';
  const inputRefs = useRef([]);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimer((prevTimer) => {
        if (prevTimer === 1) {
          setIsResendEnabled(true);
          clearInterval(interval);
          return 0;
        }
        return prevTimer - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const handlePinChange = (e, index) => {
    const { value } = e.target;
    if (/^[0-9]$/.test(value) || value === '' ) {
        const newPins = [...pins];
        newPins[index] = value;
        setPins(newPins);

        if (value !== '' && index < 5) {
            inputRefs.current[index + 1].focus();
        }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && pins[index] === '' && index > 0) {
        inputRefs.current[index - 1].focus();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    const code = pins.join('');
    if (code.length !== 6) {
      setError('Please enter the 6-digit code');
      return;
    }

    try {
      const data = await verifyEmail(email, code, role);
      setSuccess(data.message);
      navigate('/email-verify-confirm');
    } catch (err) {
      setError(err.message);
    }
  };

  const handleResend = () => {
    // Add logic to resend the verification code
    setTimer(60);
    setIsResendEnabled(false);
    const interval = setInterval(() => {
        setTimer((prevTimer) => {
          if (prevTimer === 1) {
            setIsResendEnabled(true);
            clearInterval(interval);
            return 0;
          }
          return prevTimer - 1;
        });
      }, 1000);
  };

  return (
    <div className="email-verify-container">
      <h2>Verification</h2>
      <p>We sent a verification code to {email}</p>
      <p>This code will expire in 10 minutes.</p>
      <form onSubmit={handleSubmit}>
        <div className="pin-inputs">
          {pins.map((pin, index) => (
            <input
              key={index}
              ref={el => inputRefs.current[index] = el}
              type="text"
              maxLength="1"
              value={pin}
              onChange={(e) => handlePinChange(e, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
            />
          ))}
        </div>
        {error && <p style={{ color: 'red' }}>{error}</p>}
        {success && <p style={{ color: 'green' }}>{success}</p>}
        <div className="button-group">
            <button type="button" onClick={handleResend} disabled={!isResendEnabled}>
            {isResendEnabled ? 'Resend' : `Resend in ${timer}s`}
            </button>
            <button type="button">Change Email</button>
        </div>
        <button type="submit">Confirm</button>
      </form>
    </div>
  );
};

export default EmailVerify;
